<template>
  <div>
    <div class="document" v-for="match in this.matchResults.results" v-bind:key="match.id">
      <div class="card-container">
        <div class="columns is-mobile">
          <div class="column">
            <!-- <div class="column-container is-pulled-left"> -->
            <div class="column-container align-left">
              <es-match class="match-icon" v-if="match.percent >= 93 || match.percent === null"/>
              <es-near-match class="match-icon" v-else/>
              <div class="block has-text-grey">
                <div>
                  <router-link
                    :to="{
                      name: 'locationDetails',
                      params: {
                        id: match.id
                      }
                    }"
                  >
                    <span class="is-primary is-bold">{{ match.matchedObject.name }} </span>
                  </router-link>
                  <span class="id">{{ match.id }}</span>
                </div>
                <div>
                  {{ match.matchedObject.street1}}
                </div>
                <div>
                  {{ match.matchedObject.city }},
                  {{ match.matchedObject.stateCode }}
                  {{ match.matchedObject.zip }}
                </div>
              </div>
            </div>
          </div>
          <div class="column has-border">
            <div class="column-container">
              <div class="block">
                <div
                  v-for="(locCodeOrganization, index) in match.locationOrganizationList"
                  v-bind:key="locCodeOrganization.organization.code"
                >
                  <div>
                    <span class="has-text-grey-darker">{{ locCodeOrganization.organization.code }}: </span>
                    <span>{{ locCodeOrganization.locCode }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column has-border" v-if="match.percent !== null">
            <div class="column-container">
              <div class="block percent-match">
                <span class="is-black percent">{{ match.percent }}%</span>
              </div>
              <div class="block">
                <div class="has-text-grey-darker">
                  <div>Match</div>
                  <div>Score</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSquareFull } from '@fortawesome/pro-solid-svg-icons';
import EsMatch from '@/components/EsMatch.vue';
import EsNearMatch from '@/components/EsNearMatch.vue';

library.add(faSquareFull);

export default {
  components: {
    EsMatch,
    EsNearMatch,
  },
  props: ['matchResults'],
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {

  },
};

</script>

<style lang="sass" scoped>
  .document
    margin-bottom: 1rem !important
    font-size: .85rem
  .card-container
    padding: .5rem 1rem
  .columns
    margin: 0
    height: 100%
    .column
      padding: 0 .5rem
      min-height: 75px
      .column-container
        display: flex
        flex-direction: row
        justify-content: center
        height: 100%
        .block
          display: flex
          flex-direction: column
          justify-content: center
          align-items: flex-start
          height: 100%
        .percent-match
          padding-right: 1rem
  .match-icon
    padding-right: 1rem

  .align-left
    justify-content: flex-start !important
  .align-right
    justify-content: flex-end !important
  .has-border
    border-left: 1px solid  rgb(222, 226, 230)
</style>
